/* @flow */

export const isNavigatorOnline = () => {
  return window.navigator.onLine;
}